import ContactClass from "src/shared/contacts/objects/Contact";

export class MerchantGroup
  extends ContactClass
  implements IMerchantGroupAbstract
{
  public merchantGroupUUID: string;
  public merchantGroupName: string;
  public merchantGroupStatus: string;
  public isAgency: boolean;

  constructor(obj: any = {}) {
    super(obj);

    this.merchantGroupUUID = obj.merchantGroupUUID;
    this.merchantGroupName = obj.merchantGroupName;
    this.merchantGroupStatus = obj.merchantGroupStatus;
    this.isAgency = obj.isAgency;
  }

  public toJSON(): object {
    return {
      ...this,
    };
  }
}

/**
 * @deprecated
 */
export default MerchantGroup;

export type IMerchantGroupAbstract = {
  merchantGroupName: string;
  merchantGroupUUID: string;
};

export interface IMerchantGroupAbstractNew {
  merchantGroupName: string;
  merchantGroupUuid: string;
}
